import LinksInfoContent from './LinksInfoContent';

export default LinksInfoContent;
